import { graphql } from "~/gql";

export const UPDATE_ORGANISATIONAL_UNIT = graphql(/* GraphQL */ `
  mutation updateOrganisationalUnit($id: Int!, $input: OrganisationalUnitUpdateInput!) {
    updateOrganisationalUnit(id: $id, input: $input) {
      id
      externalReference
      name
      order
      gpmDangerThreshold
      parent {
        id
        externalReference
        name
        order
        gpmDangerThreshold
      }
      children {
        id
        externalReference
        name
        order
        gpmDangerThreshold
      }
    }
  }
`);
